import * as Collaborators from './Collaborators';
import * as Partners from './Partners';

export default {
  Partners,
  Collaborators,
};
